/** Promoted Connector installers on api.maestroaudio.net (#1564 a2). */
export const PROMOTED_DOWNLOAD_API = 'https://api.maestroaudio.net/download';

export const MAC_DOWNLOAD_CHOOSER_URL = `${PROMOTED_DOWNLOAD_API}/mac`;

export function promotedMacDownloadUrl(arch) {
  if (arch === 'intel' || arch === 'x86_64') return `${PROMOTED_DOWNLOAD_API}/mac/intel`;
  if (arch === 'arm' || arch === 'aarch64' || arch === 'arm64') return `${PROMOTED_DOWNLOAD_API}/mac/arm64`;
  return MAC_DOWNLOAD_CHOOSER_URL;
}

export function promotedWindowsDownloadUrl() {
  return `${PROMOTED_DOWNLOAD_API}/windows`;
}

/** Versioned R2 mirror DMG for letters / explicit version links. */
export function versionedMacDmgUrl(version, arch) {
  const v = String(version || '').replace(/^v/i, '').trim();
  if (!v) return promotedMacDownloadUrl(arch);
  const tag = `v${v}`;
  const suffix = arch === 'intel' || arch === 'x86_64' ? 'x86_64' : 'aarch64';
  return `https://api.maestroaudio.net/downloads/${tag}/Maestro_${v}_${suffix}.dmg`;
}
